import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { AppConfigService } from '@m4u-angular/configuration/app.config.service';
import { SysGlobals } from '@m4u-angular/core/framework/sysglobals';
import { ShareDialogComponent } from '@ui/dialogs/share-dialog/share-dialog.component';
import { Observable } from 'rxjs';
import { BaseEntity, BaseEntityResponse, BaseResponse, FileView, SharingInformation, RenderedTemplate, NotificationTemplateListView } from '@base/entities/BaseEntities';
import { EnumNotificationDeliveryOptions } from './sysenums.enum';
import { BaseService } from '@base/service/BaseService';
import { ShareEndpoint } from '../endpoints/share.endpoint';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShareService extends BaseService {
    public ViewContainerRef: ViewContainerRef;

    private _notificationTemplates: NotificationTemplateListView[] = [];

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private shareEndpoint: ShareEndpoint) {
        super();
    }

    async OpenShareDialog(componentName: string,
        entityType: string,
        getRenderedTemplate: (notificationTemplateID: number, deliveryOption: EnumNotificationDeliveryOptions) => Observable<BaseEntityResponse<RenderedTemplate>>,
        share: (sharingInformation: SharingInformation) => Observable<BaseEntityResponse<FileView>>) {


        this._notificationTemplates = (await firstValueFrom(this.shareEndpoint.GetNotificationsTemplates())).Entities;

        if (!this.GetNotificationTemplatesByPageAndEntity(componentName, entityType).length) {
            this.UI.StopMessage(this.RC("msgShareNotificationTemplateNotFoundError"));
            return;
        }

        const shareDialog = this.CreateInstance();
        shareDialog.GetRenderedTemplate = getRenderedTemplate;
        shareDialog.Share = share;

        shareDialog.PageName = componentName;
        shareDialog.ShareEntityType = entityType;

        shareDialog.ShowDialogShort((e) => { });
    }

    GetNotificationTemplatesByPageAndEntity(pageName: string, entityType:string) {
        return this._notificationTemplates?.filter(x => x.PageName == pageName && (x.EntityType == entityType || !x.EntityType || !entityType));
    }

    GetDefaultOnGetRenderedTemplate() {
        return (notificationTemplateID: number, deliveryOption: EnumNotificationDeliveryOptions) => this.shareEndpoint.GetRenderedTemplate(notificationTemplateID, deliveryOption);
    }

    private CreateInstance(): ShareDialogComponent {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ShareDialogComponent);
        const componentRef = this.ViewContainerRef.createComponent<any>(componentFactory);
        return componentRef.instance;
    }
}